'use strict';
/**
 * Attention!
 * Cyrillic comments in this file cause an error when "concatenateModules" is enabled
 */
import product_sliders from "./product_sliders";
import gallery_360 from "./gallery_360";

// $(document).ready(function(){
//     const script = document.createElement('script');
//     script.src = 'https://app.call-tracking.by/scripts/phones.js?fb427c2b-c1ed-4bd7-9af7-e75c74efc077';
//     script.async = true;
//     document.body.appendChild(script);
// })

$(document).ready(function () {
    // Tabs in filters
    $(".filters").tabs({
        active: false,
        collapsible: true
    });

    // Popup with routes
    $('#mobile_map').popup({
        scrolllock: true,
        vertical: 'bottom',
        background: false,
        keepfocus: false,
        autozindex: true,
        blur: true
    });

    $('.rate-toggle').click(function () {
        $('.rate-instructions-photo').slideToggle();
    });

    // Popup for photo/video presentation
    $('#presentation').popup({
        scrolllock: true
    });

    // Popup for complaint section
    $('#complain').popup({
        scrolllock: true
    });

    // Popup with phone numbers
    $('#phones').popup({
        scrolllock: true
    });

    // Popup to find out the price
    $('#order').popup({
        scrolllock: true
    });

    // Popup to find out the price
    $('#price').popup({
        scrolllock: true
    });

    // Popup "What will be the discount?"
    $('#discount').popup({
        scrolllock: true
    });

    // Popup "Get a customer card"
    $('#client').popup({
        scrolllock: true
    });

    // Popup Store
    $('#shop-popup-01').popup({
        scrolllock: true
    });
    $('#shop-popup-02').popup({
        scrolllock: true
    });
    $('#shop-popup-03').popup({
        scrolllock: true
    });
    $('#shop-popup-04').popup({
        scrolllock: true
    });

    // Popup Buy online
    $('#order-catalog').popup({
        scrolllock: true
    });

    // FAQ accordion
    $(".faq-list").accordion({
        collapsible: true,
        heightStyle: "content"
    });

    // Expanded search
    $("#header_search").click(function () {
        $(".search").slideToggle();
        $(".search-live-overlay").slideToggle();
        $('.search_input').focus();
    });

    $(".search_clear").click(function () {
        $(".search").slideToggle();
        $(".search-live-overlay").slideToggle();
    });

    // Message sent
    $("#complain_submit").click(function (e) {
        e.preventDefault();
        $('#popup-content').addClass('none');
        $('#popup-complete').addClass('active');
    });
    $(".complain_close").click(function (e) {
        e.preventDefault();
        $('#popup-content').removeClass('none');
        $('#popup-complete').removeClass('active');
    });

    // Expanded menu
    $(".header_burger").click(function () {
        var header = $(".target");
        header.toggleClass("opened");
        $("body").toggleClass("disabled-scroll");
    });

    $(".navigation-bottom .link").click(function (e) {
        e.preventDefault();
        $('.header-map').addClass('opened');
    });

    $(".mobile-links_item__menu").click(function (e) {
        e.preventDefault();
        $('.header-map').removeClass('opened');
    });

    // Menu operation
    let menuHover = function () {
        // Находим все элементы, на которых нужно обработать события
        let levelFirstItems = document.querySelectorAll('.level-first > .navigation-menu_item');
        let levelSecondItems = document.querySelectorAll('.level-second > .submenu_item');

        // Обработчик события для .level-first > .navigation-menu_item
        levelFirstItems.forEach(function (item) {
            item.addEventListener('mouseover', function () {
                let siblings = item.parentElement.querySelectorAll('.navigation-menu_item');
                siblings.forEach(function (sibling) {
                    sibling.classList.remove('hover');
                });
                item.classList.add('hover');
            });
        });

        // Обработчик события для .level-second > .submenu_item
        levelSecondItems.forEach(function (item) {
            item.addEventListener('mouseover', function () {
                let siblings = item.parentElement.querySelectorAll('.submenu_item');
                siblings.forEach(function (sibling) {
                    sibling.classList.remove('hover');
                });
                item.classList.add('hover');
            });
        });
    };

    // Проверяем ширину экрана
    let ww = window.innerWidth;
    if (ww > 1024) {
        menuHover();
    }

    // Обработчик изменения размера окна
    window.addEventListener('resize', function () {
        let ww = window.innerWidth;
        if (ww > 1024) {
            menuHover();
        }
    });


    //show full SEO text
    $('.show_all__link').click(function () {
        $(this).remove();
        $('.show_all__text').removeClass('crop');
    });

    // scroll to active tab on text pages
    if ($('section').is('.tabs')) {
        var tab_position = $('.tabs-all .tabs-list-item .active').parent().position();
        $('.tabs').scrollLeft(tab_position.left - 5);
    }

    // Инициализация
    let galleryViewMob = document.querySelector('.gallery-view-mob');
    if (galleryViewMob) {
        let images = document.querySelectorAll('.gallery-view-mob img');

        // Функция для обновления высоты изображений
        function updateImageHeight() {
            let contentViewWidth = galleryViewMob.offsetWidth;
            images.forEach(function (img) {
                img.style.height = contentViewWidth + 'px';
            });
        }

        // Инициализация высоты при загрузке страницы
        updateImageHeight();

        // Обработчик изменения размера окна
        window.addEventListener('resize', function () {
            updateImageHeight();
        });
    }

    // TODO replace scroll with scss @mixin scroll()
    jQuery('.scrollbar-macosx').scrollbar();
});


// For the detailed product page
// Function to get the ID value
function getGalleryID() {
    let element = document.querySelector('[id^="g360-"]')
    return element ? element.id.replace('g360-', '') : null
}

function scrollOtherModels() {
    if (sessionStorage.getItem('other-models') === 'need_to_scroll_up') {
        window.scrollTo(0, 0)
        sessionStorage.removeItem('other-models')
    }
}

try {
    BX.ready(() => {
        $(document).ready(function () {
            new product_sliders()
            const galleryID = getGalleryID()
            if (galleryID) {
                new gallery_360(galleryID)
            }
            scrollOtherModels()
        })

        BX.addCustomEvent('onComponentAjaxHistorySetState', () => {
            $(document).ready(function () {
                new product_sliders()
                const galleryID = getGalleryID()
                if (galleryID) {
                    new gallery_360(galleryID)
                }
                scrollOtherModels()
            })
        })

        BX.addCustomEvent('onComponentAjaxHistoryGetState', () => {
            $(document).ready(function () {
                new product_sliders()
                const galleryID = getGalleryID()
                if (galleryID) {
                    new gallery_360(galleryID)
                }
                scrollOtherModels()
            })
        })
    })

} catch (error) {
    console.warn('BX is not defined. Custom events will not be registered.', error)
    $(document).ready(function () {
        new product_sliders()
        const galleryID = getGalleryID()
        if (galleryID) {
            new gallery_360(galleryID)
        }
        scrollOtherModels()
    })
}
window.addEventListener('popstate', function () {
    new product_sliders()
    const galleryID = getGalleryID()
    if (galleryID) {
        new gallery_360(galleryID)
    }
    scrollOtherModels()
})


// Фиксит проблему в Chrome и Safari с пропадающими svg иконками после перезагрузки страницы
document.addEventListener('DOMContentLoaded', () => {
    document.body.querySelectorAll('svg use').forEach(use => {
        const href = use.getAttribute('href') || use.getAttribute('xlink:href');

        // Проверяем, что в ссылке есть фрагмент (решётка) и это НЕ просто локальный #id
        // Варианты, которые ловим:
        //   /sprite.svg?1#heart
        //   sprite.svg#heart
        //   //site.com/sprite.svg#heart
        // А вот эти НЕ трогаем:
        //   #heart
        //   javascript:void(0)
        if (href && href.includes('#') && !href.startsWith('#')) {
            // Самая лёгкая и рабочая магия Chrome
            use.href.baseVal = use.href.baseVal;
        }
    });
});